// Venue type codes (matching backend database configuration)
export const VenueType = {
  GAMING: 'GAMING',
  SNOOKER: 'SNOOKER',
  KIDS_PLAYAREA: 'KIDS_PLAYAREA',
} as const;

export type VenueTypeCode = typeof VenueType[keyof typeof VenueType];
